import { Button } from '@lifeomic/chroma-react/components/Button';
import React from 'react';
import { useIntl } from 'react-intl';
import { messages } from '../messages';
import { useRequestExecutiveSummary } from './useRequestExecutiveSummary';

type RegenerateActionItemsProps = {
  patientId: string;
  crdDurableId?: string;
  onGenerate: () => void;
};

export const RegenerateActionItems: React.FC<RegenerateActionItemsProps> = ({
  patientId,
  crdDurableId,
  onGenerate,
}) => {
  const { requestExecutiveSummary } = useRequestExecutiveSummary({ patientId });
  const { formatMessage } = useIntl();

  const handleClick = () => {
    if (!crdDurableId) {
      console.error('Cannot regenerate action items without a CRD selected');
      return;
    }
    requestExecutiveSummary(
      {
        crdId: crdDurableId,
        requestedSummaries: [], // do not regenerate any summaries
        skipActionItems: false, // include action items when regenerating action plan explicitly
      },
      { isRegenerate: true },
    );
    onGenerate?.();
  };

  return (
    <Button onClick={handleClick} fullWidth disabled={!crdDurableId}>
      {formatMessage(messages.regenerateActionPlan)}
    </Button>
  );
};
